import nuevo1 from '../images/content-master/Nuevo 1.jpg';
import nuevo2 from '../images/content-master/Nuevo 2.jpg';
import goku from '../images/content-master/goku.jpg';
import nuevo5 from '../images/content-master/nuevo5.png';
import nox from '../images/content-master/Nox.jpg';
import Monky from '../images/content-master/Monky.png';
import koala from '../images/content-master/Koala.jpg';
import zorro from '../images/content-master/Zorro.jpg';
import zorrito from '../images/content-master/zorrito.png';

const contentMaster = [
	{
		id: '01',
		title: 'Escultura Goku',
		image: goku,
		imageWebp: goku,
		description: 'Escultura desde cero para impresión con el proceso de cortes y encastes.',
		url: '',
	},
	{
		id: '02',
		title: 'Escultura para impresión',
		image: nuevo1,
		imageWebp: nuevo1,
		description:
			'Basados en un concepto 2D crearemos esta fantástica escultura para impresión con BLENDER.',
		url: 'https://www.youtube.com/watch?v=m8xzbbDzWVM',
	},
	{
		id: '03',
		title: 'Crea personajes para impresión',
		image: nuevo2,
		imageWebp: nuevo2,
		description: 'Aprende Blender desde cero y crea fantásticos personajes para impresión 3D.',
		url: 'https://www.youtube.com/watch?v=asLI5F-YN9g',
	},
	{
		id: '04',
		title: 'Koala',
		image: koala,
		imageWebp: koala,
		description:
			'Con este entrenamiento encontrarás tu flujo de trabajo para lograr tus primeras figuras digitales.',
		url: 'https://www.youtube.com/watch?v=y66tgE1C_MI',
	},
	{
		id: '05',
		title: 'Niño warrior',
		image: nuevo5,
		imageWebp: nuevo5,
		description:
			'Sigue tu curva de aprendizaje creando este fantástico personaje aplicando técnicas de escultura en Blender.',
		url: 'https://www.youtube.com/watch?v=y66tgE1C_MI',
	},
	{
		id: '06',
		title: 'Monky',
		image: Monky,
		imageWebp: Monky,
		description:
			'Sigue tu proceso de aprendizaje con este fantástico modelo donde el objetivo es encontrar tu flujo de trabajo.',
		url: 'https://www.youtube.com/watch?v=y66tgE1C_MI',
	},
	{
		id: '07',
		title: 'Zorro',
		image: zorro,
		imageWebp: zorro,
		description:
			'No importa si estas en cero nuestro metodo de estudio te ayudara a organizar tu curva de aprendizaje.',
		url: 'https://www.youtube.com/watch?v=y66tgE1C_MI',
	},
];

export const contentMaster2 = [
	{
		id: '01',
		title: 'Escultura Zorrito',
		image: zorrito,
		imageWebp: zorrito,
		description: 'Personaje estilizado diseñado para impresión 3D con iluminación integrada.',
		url: '',
	},
	{
		id: '02',
		title: 'Nox',
		image: nox,
		imageWebp: nox,
		description:
			'Crearemos este fantástico personaje en Blender y lo dejaremos listo para imprimir.',
		url: '',
	},
	{
		id: '03',
		title: 'Escultura Goku',
		image: goku,
		imageWebp: goku,
		description: 'Escultura desde cero para impresión con el proceso de cortes y encastes.',
		url: '',
	},
	{
		id: '04',
		title: 'Escultura para impresión',
		image: nuevo1,
		imageWebp: nuevo1,
		description:
			'Basados en un concepto 2D crearemos esta fantástica escultura para impresión con BLENDER.',
		url: 'https://www.youtube.com/watch?v=m8xzbbDzWVM',
	},
	{
		id: '05',
		title: 'Crea personajes para impresión',
		image: nuevo2,
		imageWebp: nuevo2,
		description: 'Aprende Blender desde cero y crea fantásticos personajes para impresión 3D.',
		url: 'https://www.youtube.com/watch?v=asLI5F-YN9g',
	},
	{
		id: '06',
		title: 'Koala',
		image: koala,
		imageWebp: koala,
		description:
			'Con este entrenamiento encontrarás tu flujo de trabajo para lograr tus primeras figuras digitales.',
		url: 'https://www.youtube.com/watch?v=y66tgE1C_MI',
	},
	{
		id: '07',
		title: 'Niño warrior',
		image: nuevo5,
		imageWebp: nuevo5,
		description:
			'Sigue tu curva de aprendizaje creando este fantástico personaje aplicando técnicas de escultura en Blender.',
		url: 'https://www.youtube.com/watch?v=y66tgE1C_MI',
	},
	{
		id: '08',
		title: 'Monky',
		image: Monky,
		imageWebp: Monky,
		description:
			'Sigue tu proceso de aprendizaje con este fantástico modelo donde el objetivo es encontrar tu flujo de trabajo.',
		url: 'https://www.youtube.com/watch?v=y66tgE1C_MI',
	},
	{
		id: '09',
		title: 'Zorro',
		image: zorro,
		imageWebp: zorro,
		description:
			'No importa si estas en cero nuestro metodo de estudio te ayudara a organizar tu curva de aprendizaje.',
		url: 'https://www.youtube.com/watch?v=y66tgE1C_MI',
	},
];

export default contentMaster;
